import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';

import {AcSplashScreenComponent} from './ac-splash-screen.component';
import {InfraDirectivesModule} from '../../directives/infra.directives.module';
import {AcIconsModule} from '../ac-icons/ac-icons.module';


@NgModule({
    imports: [
        CommonModule,
        AcIconsModule,
        InfraDirectivesModule,
    ],
    declarations: [
        AcSplashScreenComponent,
    ],
    entryComponents: [
        AcSplashScreenComponent,
    ],
    exports: [
        AcSplashScreenComponent,
    ]
})
export class AcSplashScreenModule {
}
